const style = {
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#181a20",
    color: "#FFF",
    padding: "30px 80px",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    margin: 0,
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flexGrow: 1,
    overflow: "hidden",
  },
  agentSelectorCard: {
    background: "#1e212b",
    borderRadius: "16px",
    border: "1px solid #2a2f3b",
    padding: "25px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  configCard: {
    background: "#1e212b",
    borderRadius: "16px",
    border: "1px solid #2a2f3b",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  cardHeader: {
    padding: "20px 25px",
    borderBottom: "1px solid #2a2f3b",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "600",
    margin: 0,
  },
  infoButton: {
    background: "none",
    border: "1px solid #3c4257",
    color: "#aeb9c4",
    borderRadius: "10px",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    transition: "background-color 0.2s, color 0.2s",
  },
  cardBody: {
    padding: "25px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flexGrow: 1,
    overflowY: "auto",
  },
  placeholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    height: "100%",
    color: "#aeb9c4",
    fontSize: "16px",
    padding: "20px",
  },
  placeholderTitle: {
    color: "#FFF",
    fontSize: "20px",
    fontWeight: "600",
    margin: "0 0 10px 0",
  },
  placeholderText: {
    margin: 0,
    maxWidth: "400px",
    lineHeight: "1.6",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "220px 1fr",
    alignItems: "center",
    gap: "20px",
  },
  label: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#aeb9c4",
  },
  input: {
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 15px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "14px",
    outline: "none",
  },
  select: {
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 15px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "14px",
    cursor: "pointer",
    outline: "none",
  },
  warningBox: {
    background: "rgba(255, 184, 0, 0.1)",
    border: "1px solid rgba(255, 184, 0, 0.3)",
    borderRadius: "12px",
    padding: "15px 20px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginTop: "10px",
  },
  warningIcon: {
    color: "#ffb800",
    flexShrink: 0,
  },
  warningText: {
    margin: 0,
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#e0e0e0",
  },
  saveButton: {
    height: "50px",
    background: "#4ecf78",
    color: "#1e212b",
    border: "none",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s",
  },
  messagePreviewContainer: {
    backgroundColor: "#E5DDD5",
    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><g fill-rule="evenodd"><g fill="%23d6cdc3" fill-opacity="0.4"><path d="M400 0L0 400V0zM0 0l400 400V0z"/></g></g></svg>')`,
    borderRadius: "12px",
    padding: "20px",
    display: "flex",
  },
  messageBubble: {
    background: "#ffffff",
    color: "#111b21",
    padding: "8px 12px",
    borderRadius: "8px",
    maxWidth: "85%",
    position: "relative",
    boxShadow: "0 1px 1px rgba(0, 0, 0, 0.08)",
  },
  bubbleTail: {
    position: "absolute",
    top: 0,
    left: "-8px",
    width: 0,
    height: 0,
    borderTop: "0px solid transparent",
    borderBottom: "10px solid transparent",
    borderRight: "8px solid #ffffff",
    borderLeft: "0px solid transparent",
  },
  bubbleBody: {
    fontSize: "14.2px",
    lineHeight: "1.4",
    whiteSpace: "pre-wrap",
    margin: 0,
    color: "#3b4a54",
    textAlign: "start",
  },
  bubbleBodyBold: {
    fontWeight: "600",
    color: "#111b21",
    textAlign: "start",
    width: "100%",
  },
  bubbleFooter: {
    position: "relative",
    float: "right",
    marginLeft: "10px",
  },
  timestamp: {
    fontSize: "11px",
    color: "#667781",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.3s ease-in-out",
  },
  modalContainer: {
    background: "#2a2f3b",
    borderRadius: "16px",
    width: "90%",
    maxWidth: "600px",
    zIndex: 1001,
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  },
  modalHeader: {
    padding: "20px 25px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #3c4257",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "600",
    margin: 0,
    color: "#FFF",
  },
  modalCloseButton: {
    background: "#3c4257",
    border: "none",
    color: "#aeb9c4",
    cursor: "pointer",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s",
  },
  modalBody: {
    padding: "15px 25px 30px 25px",
    color: "#aeb9c4",
    fontSize: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  modalIntroText: {
    textAlign: "center",
    marginBottom: "10px",
    fontSize: "16px",
    color: "#FFF",
  },
  modalStep: {
    display: "flex",
    alignItems: "flex-start",
    gap: "20px",
  },
  stepNumber: {
    background: "#4ecf78",
    color: "#1e212b",
    minWidth: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "bold",
    flexShrink: 0,
  },
  stepContent: {
    display: "flex",
    flexDirection: "column",
  },
  stepTitle: {
    fontSize: "16px",
    fontWeight: "600",
    margin: "0 0 5px 0",
    color: "#FFF",
    display: "flex",
    alignItems: "center",
  },
  stepIcon: {
    marginRight: "10px",
    color: "#4ecf78",
  },
  stepDescription: {
    margin: 0,
    lineHeight: "1.6",
    color: "#aeb9c4",
  },
};

export default style;
